
import React from 'react';
// template components
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import highResDesktopImageWebp from './images/insurance-hero.webp';
import highResMobileImageWebp from './images/insurance-hero-mobile.webp';
// low res images
import { lowResImageDesktop, lowResImageMobile } from './lowResImages';
// styles
import { HeroSectionStyled } from './styles';

export default () => {
  return (
    <HeroSectionStyled
      backgroundVariant='lightB'
      themeType='lightTheme'
      sectionId='insurance-hero'
      moduleName='hero-module'
      moduleVariation='A'
      productName='Insurance Policies'
      headingText={<>Protect today and every day after <WidowBlock>with insurance.</WidowBlock></>}
      descriptionText={<>Insurance is the best way to protect the life you&#39;ve worked hard to build and give you (and your family) more financial flexibility when it&#39;s needed most.</>}
      ctaPrimary={{
        linkUrl: '/find-a-financial-advisor/',
        buttonText: 'Get insurance',
        ariaLabel: 'Get insurance with a financial professional.',
        children: '',
      }}
      backgroundImageAriaLabel='A father helping his son pack for college'
      backgroundImageDesktop={highResDesktopImageWebp.toString()}
      backgroundImageMobile={highResMobileImageWebp.toString()}
      backgroundImageDesktopLowRes={lowResImageDesktop}
      backgroundImageMobileLowRes={lowResImageMobile}
    />
  );};
